/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index anchor to autogenerate all the components and extensions
 * Used by "prepareAnchors"
 */

import Anchor from './anchor/Anchor'
export * from './anchor/Anchor'
export default Anchor
